// extracted by mini-css-extract-plugin
module.exports = {"icon":"SpeakerDocumentStyles__icon___1s1tU","speakerDocumentContainer":"SpeakerDocumentStyles__speakerDocumentContainer___3CtZ8"};